export default "__VITE_ASSET__CyYPd5yl__"